import { GoogleLogo, ShieldCheck } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

/** Bottom-of-page hero pushing anonymous visitors to sign up. */
export default function SignupCTA() {
  const { user, signIn } = useAuth();
  if (user) return null;
  return (
    <section
      data-testid="signup-cta-section"
      className="max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-20 relative z-10"
    >
      <div className="border-2 border-black bg-emerald-500 text-black p-8 md:p-12 shadow-[10px_10px_0px_rgba(0,0,0,1)]">
        <div className="font-mono-plex text-[10px] font-semibold mb-3 flex items-center gap-2">
          <ShieldCheck weight="fill" className="w-3.5 h-3.5" />
          FREE · NO CREDIT CARD · ONE TAP
        </div>
        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight mb-4 max-w-3xl">
          Sign up and stop scrolling past claims you can&apos;t verify.
        </h2>
        <p className="text-[15px] md:text-lg leading-relaxed max-w-2xl mb-8">
          Anonymous browsers get three free checks. Sign in with Google and we&apos;ll drop the cap.
          We only capture your email — nothing else.
        </p>
        <button
          type="button"
          onClick={signIn}
          data-testid="signup-cta-button"
          className="inline-flex items-center gap-2 bg-black text-white px-6 py-4 font-mono-plex text-xs font-semibold hover:bg-zinc-900 transition-colors"
        >
          <GoogleLogo weight="bold" className="w-4 h-4" />
          SIGN UP FREE WITH GOOGLE
        </button>
      </div>
    </section>
  );
}
